<template>
  <v-dialog v-model="value" persistent max-width="800px">
    <material-card
      color="orange"
      title="Patients Enrollment"
      text="Input patients number per months and country"
    >
      <br />

      <v-layout justify-center wrap>
        <v-flex md12 xs12 style="overflow: auto; height: 50vh; width: 100%">
          <v-simple-table dense style="width: 100%; background: #eee">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 50px">
                    Months/Countries
                  </th>
                  <th
                    v-for="(n, index) in countries"
                    :key="index"
                    style="width: 50px"
                  >
                    {{ n }}
                  </th>
                  <th colspan="20"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(n, index) in totalMonths" :key="index">
                  <td>
                    <b>{{ index + 1 }}° - {{monthFromStart(index)}}</b>
                  </td>
                  <td v-for="(n, index2) in countries" :key="index2" style="">
                    <input
                      type="text"
                      style="max-width: 30px; background: white"
                      dense
                      v-model="patients[n][index]"
                    />
                  </td>
                  <th colspan="20"></th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>

        <v-flex md6 xs6 text-right>
          <br />
          <v-text-field
            label="New country"
            style="max-width: 150px"
            v-model="newCountry"
            prepend-icon="mdi-delete"
            @click:prepend="removeCountry"
            append-icon="mdi-plus"
            @click:append="addCountry"
          >
          </v-text-field>
        </v-flex>

        <v-flex md6 xs6 text-right>
          <br />
          <v-btn
            small
            class="mx-1 font-weight-light"
            color="success"
            @click="close()"
            >Close</v-btn
          >
        </v-flex>
      </v-layout>
    </material-card>
  </v-dialog>
</template>

<script>

import  moment  from 'moment'

export default {
  props: {
    value: { type: Boolean, default: true },
    totalMonths: { type: Number, default: 0 },
    startMonth: {type: String},
    patients: {
      type: Object,
      default: () => {
        return {};
      },
    },
    timepointMonths: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    loading: false,
    newCountry: "",
  }),
  watch: {
    patients() {
      this.$emit("update:patients", this.patients);
    },
  },
  computed: {
    countries() {
      return Object.keys(this.patients);
    },
  },
  methods: {
    addCountry() {
      if (!this.patients[this.newCountry]) {
        this.$set(this.patients, this.newCountry, []); // Observable
        this.newCountry = null;
        this.$emit("update:patients", this.patients);
      }
    },
    monthFromStart(index) {
      const month = moment(this.startMonth + '-01')
      month.add(index, 'month')
      return month.format("MMM y")
    },
    removeCountry() {
      this.$delete(this.patients, this.newCountry); // Observable
      this.newCountry = null;
      this.$emit("update:patients", this.patients);
    },
    close() {
      this.$emit("input", false);
    },
  },
};
</script>


<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>

<style>
.handsontable {
  z-index: 0 !important;
}
</style>